import { createElement } from "@wordpress/element";

/**
 * Internal dependencies
 */
import { HStack } from '../h-stack';
import { Text } from '../text';
import { Spacer } from '../spacer';
import { space } from '../ui/utils/space';
import { RangeControl, NumberControlWrapper } from './styles';
import { COLORS } from '../utils/colors-values';
export const InputWithSlider = _ref => {
  let {
    min,
    max,
    label,
    abbreviation,
    onChange,
    value
  } = _ref;
  return createElement(Spacer, {
    as: HStack,
    spacing: 4
  }, createElement(NumberControlWrapper, {
    min: min,
    max: max,
    label: label,
    hideLabelFromVision: true,
    value: value,
    onChange: onChange,
    prefix: createElement(Spacer, {
      as: Text,
      paddingLeft: space(3.5),
      color: COLORS.ui.theme,
      lineHeight: 1
    }, abbreviation),
    hideHTMLArrows: true
  }), createElement(RangeControl, {
    label: label,
    hideLabelFromVision: true,
    min: min,
    max: max,
    value: value,
    onChange: onChange,
    withInputField: false
  }));
};
//# sourceMappingURL=input-with-slider.js.map